import type { WorkspaceId } from '../../../common/types/new-avp-experience/workspace';

export const getAssetsReportingBaseURL = (workspaceId: WorkspaceId) =>
	`/gateway/api/jsm/reporting/assets/workspace/${workspaceId}`;

export const getProductMetricsUrl = (workspaceId: WorkspaceId, products: string[]) => {
	const queryString = products.length
		? `?${products.map((product) => `product=${product}`).join('&')}`
		: '';

	return `${getAssetsReportingBaseURL(workspaceId)}/metrics${queryString}`;
};

export const getChartConfigurationsUrl = (workspaceId: WorkspaceId, metricId: string) =>
	`${getAssetsReportingBaseURL(workspaceId)}/metrics/${metricId}/chart-configurations`;

export const getValuesDetailsUrl = (workspaceId: WorkspaceId) =>
	`${getAssetsReportingBaseURL(workspaceId)}/values/details`;

export const getValuesUrls = (workspaceId: WorkspaceId) =>
	`${getAssetsReportingBaseURL(workspaceId)}/values`;

export const getChartDataUrl = (workspaceId: WorkspaceId) =>
	`${getAssetsReportingBaseURL(workspaceId)}/chart`;

export const getPreferencesUrl = (workspaceId: WorkspaceId, featureGateKey: string) =>
	`${getAssetsReportingBaseURL(workspaceId)}/preferences?featureGateKey=${featureGateKey}`;

export const updatePreferencesUrl = (workspaceId: WorkspaceId, featureGateKey: string) =>
	`${getAssetsReportingBaseURL(workspaceId)}/preferences/${featureGateKey}?featureGateKey=${featureGateKey}`;

export const getHydrateUrl = (workspaceId: WorkspaceId) =>
	`${getAssetsReportingBaseURL(workspaceId)}/hydrate`;
